import { InvalidPartsOrderCopyProps } from './types'
import { SimpleOrderBlocker } from './SimpleOrderBlocker'

export const InsurancePartsUnsupportedCopy = (
  _props: InvalidPartsOrderCopyProps
) => {
  return (
    <SimpleOrderBlocker
      title="We do not cover parts for your pump model under your insurance plan."
      content="Your insurance provides a limited reimbursement for pump parts, so parts
        for upgrade models are not eligible for free."
    />
  )
}
